import moment from 'moment';
import { PublicProvider } from '../../../api/Providers';
import { ssFetchJSON } from '../../ssFetch';

export type ProviderOnboardingPromptStatus = {
  prompt_for_payments_onboarding: boolean;
  prompt_for_availability: boolean;
  prompt_for_clients: boolean;
  prompt_for_location: boolean;
  prompt_for_appointments: boolean;
  prompt_for_google_calendar: boolean;
  prompt_for_setup_payments: boolean;
  prompt_for_profile_photo: boolean;
  prompt_for_gallery_image: boolean;
  prompt_for_subscribe?: boolean;
  prompt_for_services: boolean;
};

export type ProviderOnboardingStatus = {
  promptStatus: ProviderOnboardingPromptStatus;
  percentComplete: number;
};

export type SignupCountdownInfo = {
  showCountdown: boolean;
  cutoff?: moment.Moment;
};

export async function fetchProviderOnboardingPromptStatus(
  providerId: number,
): Promise<ProviderOnboardingPromptStatus> {
  return ssFetchJSON(
    `/api/v2/providers/${providerId}/onboarding-prompt-status.json`,
    { ssCache: 5 }, // Some page loads trigger multiple fetches in rapid succession
  );
}

export function calculatePercentComplete(steps: ProviderOnboardingPromptStatus): number {
  const completedStepsCount = Object.values(steps)
    .filter(shouldPrompt => !shouldPrompt)
    .length;
  const totalStepsCount = Object.keys(steps).length;
  return Math.floor((completedStepsCount / totalStepsCount) * 100);
}

export function calculateSignupCountdownInfo(
  provider: Pick<PublicProvider, 'creation_time'>,
  onboardingStatus?: ProviderOnboardingStatus,
): SignupCountdownInfo {
  if (!provider.creation_time) {
    return { showCountdown: false };
  }

  const status = onboardingStatus?.promptStatus;
  const hasRemainingSteps = status?.prompt_for_availability
    || status?.prompt_for_services
    || status?.prompt_for_location
    || status?.prompt_for_gallery_image;
  const cutoff = moment.utc(provider.creation_time).add(7, 'days');

  return {
    showCountdown: !!(hasRemainingSteps && cutoff.isAfter(moment.utc())),
    cutoff,
  };
}
